import { getTimeRange } from 'utils'
import type { TDatadogErrorLog } from 'utils/datadog/types'

const DEFAULT_VIDEOS_LIMIT = 5

export const DEFAULT_QUERY_FILTERS = {
  limit: DEFAULT_VIDEOS_LIMIT,
  filters: {
    timeRange: getTimeRange('day', 7),
  },
}

export const GET_POSTS_FROM_TERRITORY_LOG: TDatadogErrorLog = {
  from: 'src/hooks/useVideosByTerritory/index.ts',
  name: 'Get Posts from Territory',
  message: 'Failed to get posts from territory',
}
